import { render, staticRenderFns } from "./GenericSettingsView.vue?vue&type=template&id=0738c5cd"
import script from "./GenericSettingsView.vue?vue&type=script&lang=js"
export * from "./GenericSettingsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports